// @ts-nocheck
import {
    getBlogHomeDataView,
    getBlogHomeMostRecentDataView,
} from "@store/Framework/Store/Data/BlogHome/BlogHomeSelectors";
import convertSelectorToHook from "@toolkit/Framework/Common/Utilities/convertSelectorToHook";

export const useBlogHomeDataView = convertSelectorToHook(getBlogHomeDataView);

export const useBlogHomeMostRecentDataView = convertSelectorToHook(getBlogHomeMostRecentDataView);
